module.exports = __webpack_public_path__ + "img/arqu-cabc-thumb.0e72027d.jpg";